(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4275],{

/***/ 19236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function getFontSize(size, element, theme) {
  if (typeof size !== "undefined") {
    return size in theme.headings.sizes ? theme.headings.sizes[size].fontSize : size;
  }
  return theme.headings.sizes[element].fontSize;
}
function getLineHeight(size, element, theme) {
  if (typeof size !== "undefined" && size in theme.headings.sizes) {
    return theme.headings.sizes[size].lineHeight;
  }
  return theme.headings.sizes[element].lineHeight;
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { element, weight, size, inline }) => ({
  root: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
    fontFamily: theme.headings.fontFamily,
    fontWeight: weight || theme.headings.sizes[element].fontWeight || theme.headings.fontWeight,
    fontSize: getFontSize(size, element, theme),
    lineHeight: inline ? 1 : getLineHeight(size, element, theme),
    margin: 0
  })
}));

/* harmony default export */ var Title_styles = (useStyles);
//# sourceMappingURL=Title.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.js





var Title_defProp = Object.defineProperty;
var Title_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Title_hasOwnProp = Object.prototype.hasOwnProperty;
var Title_propIsEnum = Object.prototype.propertyIsEnumerable;
var Title_defNormalProp = (obj, key, value) => key in obj ? Title_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Title_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Title_hasOwnProp.call(b, prop))
      Title_defNormalProp(a, prop, b[prop]);
  if (Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(b)) {
      if (Title_propIsEnum.call(b, prop))
        Title_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Title_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Title_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  order: 1
};
const Title = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Title", defaultProps, props), { className, order, children, unstyled, size, weight, inline } = _a, others = __objRest(_a, ["className", "order", "children", "unstyled", "size", "weight", "inline"]);
  const { classes, cx } = Title_styles({ element: `h${order}`, weight, size, inline }, { name: "Title", unstyled });
  if (![1, 2, 3, 4, 5, 6].includes(order)) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(Text/* Text */.x, Title_spreadValues({
    component: `h${order}`,
    ref,
    className: cx(classes.root, className)
  }, others), children);
});
Title.displayName = "@mantine/core/Title";


//# sourceMappingURL=Title.js.map


/***/ }),

/***/ 55308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/key-claim",
      function () {
        return __webpack_require__(24701);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-set-state/use-set-state.js


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function useSetState(initialState) {
  const [state, _setState] = (0,react.useState)(initialState);
  const setState = (0,react.useCallback)((statePartial) => _setState((current) => __spreadValues(__spreadValues({}, current), typeof statePartial === "function" ? statePartial(current) : statePartial)), []);
  return [state, setState];
}


//# sourceMappingURL=use-set-state.js.map

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 35 modules
var esm = __webpack_require__(58880);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./utils/yup/index.ts
var yup = __webpack_require__(33464);
// EXTERNAL MODULE: ./containers/auth.tsx + 4 modules
var auth = __webpack_require__(88156);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(76166);
// EXTERNAL MODULE: ./api/index.ts
var api = __webpack_require__(57380);
;// CONCATENATED MODULE: ./api/product-key/index.api.ts





var ProductKeyApi = /*#__PURE__*/ function(Api) {
    "use strict";
    (0,_inherits/* default */.Z)(ProductKeyApi, Api);
    var _super = (0,_create_super/* default */.Z)(ProductKeyApi);
    function ProductKeyApi() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ProductKeyApi);
        return _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
    }
    var _proto = ProductKeyApi.prototype;
    _proto.redeem = function redeem(serial_code) {
        var skipError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        return this.createApi("/v2/ProductKey/redeem", "post", {
            serial_code: serial_code
        }, {
            skipError: skipError
        });
    };
    return ProductKeyApi;
}(api/* Api */.V);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Input/Input.js + 11 modules
var Input = __webpack_require__(94151);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(76627);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
;// CONCATENATED MODULE: ./pages/key-claim/components/redeem-input.tsx








var MaskedInputComponent = function(_param) {
    var value = _param.value, onChange = _param.onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange"
    ]);
    var inputRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (inputRef.current) {
            inputRef.current.setSelectionRange(value.length, value.length);
        }
    }, [
        value
    ]);
    var parseInput = function(input) {
        var inputValue = input.toUpperCase().replace(/[^A-Z0-9-]/g, "");
        return inputValue;
    };
    var handleChange = function(event) {
        var inputValue = parseInput(event.target.value);
        onChange(inputValue);
    };
    var formatValue = function(val) {
        var parts = val.match(/.{1,16}/g) || [];
        return parts.join("-");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        mask: "******-******-********",
        value: formatValue(value),
        onChange: handleChange,
        maskChar: null,
        placeholder: "______-______-________"
    }, props), {
        children: function(inputProps) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputProps), {
                ref: inputRef
            }));
        }
    }));
};
var RedeemInput = function(param) {
    var onChange = param.onChange, value = param.value;
    var ref = (0,esm/* useTranslation */.$G)("common"), tCommon = ref.t;
    var id = (0,react.useId)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Input/* Input.Wrapper */.I.Wrapper, {
        id: id,
        label: tCommon("product-key"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaskedInputComponent, {
                size: "md",
                onChange: function(data) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(data);
                },
                value: value || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    c: "dimmed",
                    children: tCommon("redeem-code-description")
                })
            })
        ]
    });
};
/* harmony default export */ var redeem_input = (RedeemInput);

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(38090);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/solid/esm/ChevronRightIcon.js


function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(ChevronRightIcon);
/* harmony default export */ var esm_ChevronRightIcon = (ForwardRef);
// EXTERNAL MODULE: ./components/ImageComponent/index.tsx
var ImageComponent = __webpack_require__(60429);
;// CONCATENATED MODULE: ./pages/key-claim/components/redeem-status-popup.tsx






var PopupContentTemplate = function(param) {
    var headerImage = param.headerImage, statusText = param.statusText, description = param.description, buttonOnClick = param.buttonOnClick, buttonText = param.buttonText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center px-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full my-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageComponent/* default */.Z, {
                    className: "w-full h-auto",
                    src: headerImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    c: "dimmed",
                    size: "md",
                    children: statusText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    size: "lg",
                    children: description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8 mb-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    size: "md",
                    onClick: function() {
                        buttonOnClick();
                    },
                    children: buttonText
                })
            })
        ]
    });
};
var useStyles = (0,create_styles/* createStyles */.k)(function() {
    return {
        close: {
            display: "none"
        },
        header: {
            display: "none"
        },
        overlay: {
            background: "rgba(0, 0, 0, 0.40) !important"
        },
        modal: {
            borderRadius: "8px",
            paddingTop: "24px !important",
            paddingLeft: "16px !important",
            paddingRight: "16px !important"
        }
    };
});
var RedeemStatusPopup = function(param) {
    var status = param.status, errorMessage = param.errorMessage, _open = param.open, open = _open === void 0 ? false : _open, onClose = param.onClose;
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var classes = useStyles().classes;
    var handleClose = function() {
        onClose === null || onClose === void 0 ? void 0 : onClose(status);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        centered: true,
        opened: open,
        onClose: handleClose,
        classNames: classes,
        closeOnEscape: false,
        closeOnClickOutside: false,
        children: [
            status === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupContentTemplate, {
                headerImage: "https://res.ggacademy.gg/user-web/images/key-claim/success-header.png",
                statusText: "".concat(t("amazing"), "!"),
                description: t("redeem-success-message"),
                buttonText: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("purchase")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronRightIcon, {
                            className: "inline-block h-4 w-4"
                        })
                    ]
                }),
                buttonOnClick: function() {
                    router.push("/course-center", undefined, {
                        shallow: true
                    });
                }
            }),
            status === "fail" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupContentTemplate, {
                headerImage: "https://res.ggacademy.gg/user-web/images/key-claim/Error.png",
                statusText: "".concat(t("error"), "!"),
                description: errorMessage || t("server_response.error.redeem.generic"),
                buttonText: t("try-again"),
                buttonOnClick: function() {
                    handleClose();
                }
            })
        ]
    });
};
/* harmony default export */ var redeem_status_popup = (RedeemStatusPopup);

;// CONCATENATED MODULE: ./pages/key-claim/index.page.tsx

















var productKeyApi = new ProductKeyApi();
var KeyClaimPage = function() {
    var formRef = (0,react.useRef)(null);
    var ref = (0,auth/* useAuth */.aC)(), setOpenAuthModal = ref.setOpenAuthModal, setAuthModalState = ref.setAuthModalState, isAuthenticated = ref.isAuthenticated, setOnAuthModalClose = ref.setOnAuthModalClose, refreshUser = ref.refreshUser;
    var ref1 = (0,react.useState)(false), statusPopupOpened = ref1[0], setPopupOpened = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(useSetState({
        status: "success",
        errorMessage: ""
    }), 2), popupState = ref2[0], setPopupState = ref2[1];
    var schema = yup/* default.object */.Z.object().shape({
        user_input: yup/* default.string */.Z.string().required().length(22)
    });
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "all",
        defaultValues: {
            user_input: ""
        },
        resolver: (0,yup_module/* yupResolver */.X)(schema)
    }), reset = ref3.reset, watch = ref3.watch, _formState = ref3.formState, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, control = ref3.control, handleSubmit = ref3.handleSubmit;
    var watchInput = watch("user_input");
    var submitForm = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var isAuth, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isValid || isSubmitting) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            refreshUser()
                        ];
                    case 1:
                        isAuth = _state.sent();
                        if (!isAuth) {
                            react_toastify_esm/* toast.info */.Am.info(t("redeem-require-login"), {
                                position: "top-center"
                            });
                            setOpenAuthModal(true);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            productKeyApi.redeem(data.user_input)
                        ];
                    case 2:
                        res = _state.sent();
                        if (res.success) {
                            setPopupState({
                                status: "success"
                            });
                        } else {
                            setPopupState({
                                status: "fail",
                                errorMessage: res.message
                            });
                        }
                        setPopupOpened(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isSubmitting,
        isValid,
        refreshUser,
        setOpenAuthModal,
        setPopupState,
        t
    ]);
    (0,react.useEffect)(function() {
        setAuthModalState({
            initialStage: "smsLogin"
        });
    }, [
        setAuthModalState
    ]);
    (0,react.useEffect)(function() {
        setOnAuthModalClose(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(isLoggedIn) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!isLoggedIn) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                handleSubmit(submitForm)()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(isLoggedIn) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            setOnAuthModalClose(undefined);
        };
    }, [
        handleSubmit,
        setOnAuthModalClose,
        submitForm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundSize: "2000px"
        },
        className: "bg-white bg-repeat min-h-screen flex flex-col bg-[url('https://res.ggacademy.gg/user-web/images/backgrounds/bg-faq.png')]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(redeem_status_popup, (0,_object_spread/* default */.Z)({
                open: statusPopupOpened,
                onClose: function() {
                    // 重置表单
                    setPopupOpened(false);
                    reset();
                }
            }, popupState)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "container max-w-sm mx-auto flex flex-col items-center flex-1 h-1 w-full mt-32",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-10 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            order: 3,
                            children: t("redeem-a-code")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "w-full px-1",
                        ref: formRef,
                        onSubmit: handleSubmit(submitForm),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                    control: control,
                                    name: "user_input",
                                    render: function(param) {
                                        var _field = param.field, onChange = _field.onChange, value = _field.value;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(redeem_input, {
                                            onChange: onChange,
                                            value: value
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "my-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    loading: isSubmitting,
                                    size: "md",
                                    disabled: !watchInput || !isValid || isSubmitting,
                                    fullWidth: true,
                                    type: "submit",
                                    children: t("submit")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var index_page = (KeyClaimPage);


/***/ }),

/***/ 76627:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(53462);
} else {}


/***/ }),

/***/ 53462:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(__webpack_require__(67294)),reactDom=__webpack_require__(73935);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r)}return e}function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation"}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else{var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select()}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else{var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length))}return{start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return{maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1)}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return-1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return!1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return!u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return!0;if(++s>=l.length)return!1}var t,n,a,i;return!isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return!1;var t,n;return(isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h)}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return"function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return(!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e)}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop)},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop()},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null)},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=reactDom.findDOMNode(_assertThisInitialized(_assertThisInitialized(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e)},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t)},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t)}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)})},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e)},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return{mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return!0}catch(r){}return!f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized(_assertThisInitialized(f)).beforePasteState,n=_assertThisInitialized(_assertThisInitialized(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end)},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else{var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end)}f.runSaveSelectionLoop()}isFunction(f.props.onFocus)&&f.props.onFocus(e)},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e)}isFunction(f.props.onBlur)&&f.props.onBlur(e)},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd()}};document.addEventListener("mouseup",r)}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e)},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""))},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e)};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value}return f.value=l,f}_inheritsLoose(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value))},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p))}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end)}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate())},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop()},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1)}else t=React.createElement("input",_extends({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);module.exports=InputElement;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(55308); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);